/**
 * CapabilityRoute — route-level guard for discipline-specific pages.
 *
 * Defense-in-depth companion to the nav gating: even if a non-immigration expert
 * types an immigration URL directly (e.g. /settings/programs-pipelines), this
 * redirects them home. Wrap the page element with the required feature flag:
 *
 *   <Route path="/settings/programs-pipelines"
 *          element={<ProtectedRoute><CapabilityRoute feature="immigrationPrograms">
 *                     <ProgramsPipelinesPage />
 *                   </CapabilityRoute></ProtectedRoute>} />
 *
 * While capabilities are still loading we render nothing (avoids a flash of the
 * page before a redirect).
 */

import React from 'react';
import { Navigate } from 'react-router-dom';
import { useCapabilities } from '../Context/CapabilityContext';

const CapabilityRoute = ({ feature, children, redirectTo = '/' }) => {
  const { features, loading } = useCapabilities();

  if (loading) return null;            // wait for the profile capability fetch
  if (features[feature]) return children;
  return <Navigate to={redirectTo} replace />;
};

export default CapabilityRoute;
